import { getNodeServiceDependencies } from '@/codeGeneration/dependenciesGetter';
import { V4UUID } from '@/firebase/database';
import {
  getLastIndexOf,
  toSnakeCase
} from '@/modules/globalModule/components/helperMethods';
import { useGlobalStore } from '@/modules/globalModule/store';
import {
  CustomCppNodeText,
  CustomNodeText,
  Node
} from '@/modules/nodesCanvasModule/components/storeClasses/node';

export const processCustomCppNode = (
  node: Node,
  customTextStr: string,
  workspaceId: V4UUID
): CustomCppNodeText => {
  const globalStore = useGlobalStore();
  console.log(node.customText);
  let customTextObj: CustomCppNodeText = node.customText as CustomCppNodeText;
  if (!customTextObj.publicMethodsDefText)
    customTextObj.publicMethodsDefText = '';
  if (!customTextObj.privateMethodsDefText)
    customTextObj.privateMethodsDefText = '';

  if (
    customTextStr.includes(
      '// add additional constructor functionality below\n'
    ) &&
    customTextStr.includes('    // end additional constructor functionality')
  ) {
    customTextObj.constructorText = customTextStr
      .slice(
        getLastIndexOf(
          customTextStr,
          '// add additional constructor functionality below\n'
        ),
        customTextStr.indexOf('    // end additional constructor functionality')
      )
      .trimEnd();
  }

  if (
    customTextStr.includes('// add custom method implementations below\n') &&
    customTextStr.includes('// end custom method implementations')
  ) {
    customTextObj.methodsText = customTextStr
      .slice(
        getLastIndexOf(
          customTextStr,
          '// add custom method implementations below\n'
        ),
        customTextStr.indexOf('// end custom method implementations')
      )
      .trimEnd();
  }

  if (
    customTextStr.includes('// customize main function below\n') &&
    customTextStr.includes('    // end main customization')
  ) {
    customTextObj.mainText = customTextStr
      .slice(
        getLastIndexOf(customTextStr, '// customize main function below\n'),
        customTextStr.indexOf('    // end main customization')
      )
      .trimEnd();
  }

  // getting topic subscription callback text
  if (node.subscribers) {
    for (let subId of node.subscribers) {
      let topic = globalStore.getTopic(subId);
      if (!topic || !topic.name) continue;
      if (
        customTextStr.includes(
          `// customize ${toSnakeCase(topic.name)}_callback below\n`
        ) &&
        customTextStr.includes(
          `    // end ${toSnakeCase(topic.name)}_callback customization\n`
        )
      ) {
        const callbackText = customTextStr
          .slice(
            getLastIndexOf(
              customTextStr,
              `// customize ${toSnakeCase(topic.name)}_callback below\n`
            ),
            customTextStr.indexOf(
              `    // end ${toSnakeCase(topic.name)}_callback customization\n`
            )
          )
          .trimEnd();
        const callbackObj = customTextObj.callbacks.find(
          (callback) =>
            callback.name === `${toSnakeCase(topic?.name!)}_callback`
        );
        if (callbackObj) {
          callbackObj.text = callbackText;
        } else {
          customTextObj.callbacks.push({
            name: `${toSnakeCase(topic.name)}_callback`,
            text: callbackText
          });
        }
      }
    }
  }
  // getting service server callback text
  getNodeServiceDependencies(workspaceId, node.id).servers.forEach(
    (srvInfo) => {
      if (
        customTextStr.includes(
          `// customize ${toSnakeCase(srvInfo.srv.name)}_srv_callback below\n`
        ) &&
        customTextStr.includes(
          `    // end ${toSnakeCase(
            srvInfo.srv.name
          )}_srv_callback customization\n`
        )
      ) {
        const callbackText = customTextStr
          .slice(
            getLastIndexOf(
              customTextStr,
              `// customize ${toSnakeCase(
                srvInfo.srv.name
              )}_srv_callback below\n`
            ),
            customTextStr.indexOf(
              `    // end ${toSnakeCase(
                srvInfo.srv.name
              )}_srv_callback customization\n`
            )
          )
          .trimEnd();
        const callbackObj = customTextObj.callbacks.find(
          (callback) =>
            callback.name === `${toSnakeCase(srvInfo.srv.name)}_srv_callback`
        );
        if (callbackObj) {
          callbackObj.text = callbackText;
        } else {
          customTextObj.callbacks.push({
            name: `${toSnakeCase(srvInfo.srv.name)}_srv_callback`,
            text: callbackText
          });
        }
      }
    }
  );
  return customTextObj;
};

export const processCustomHppText = (node: Node, customHppText: string) => {
  let customTextObj: CustomCppNodeText = node.customText as CustomCppNodeText;
  if (!customTextObj.publicMethodsDefText)
    customTextObj.publicMethodsDefText = '';
  if (!customTextObj.privateMethodsDefText)
    customTextObj.privateMethodsDefText = '';

  if (
    customHppText.includes('// add custom imports below\n') &&
    customHppText.includes('// end custom imports')
  ) {
    customTextObj.importText = customHppText
      .slice(
        getLastIndexOf(customHppText, '// add custom imports below\n'),
        customHppText.indexOf('// end custom imports')
      )
      .trimEnd();
  }

  if (
    customHppText.includes('// add custom public methods below\n') &&
    customHppText.includes('        // end custom public methods')
  ) {
    customTextObj.publicMethodsDefText = customHppText
      .slice(
        getLastIndexOf(customHppText, '// add custom public methods below\n'),
        customHppText.indexOf('        // end custom public methods')
      )
      .trimEnd();
  }
  if (
    customHppText.includes('// add custom private methods below\n') &&
    customHppText.includes('        // end custom private methods')
  ) {
    customTextObj.privateMethodsDefText = customHppText
      .slice(
        getLastIndexOf(customHppText, '// add custom private methods below\n'),
        customHppText.indexOf('        // end custom private methods')
      )
      .trimEnd();
  }
  return customTextObj;
};
